module.exports = __webpack_public_path__ + "static/media/resend_invitation_error.4e9ee8fb.svg";